var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#112631","fillRule":"evenodd","d":"M5.834 9.314l4.714 4.714.273.267c1.354 1.289 1.905 1.209 3.38-.267l4.715-4.714 1.06 1.061-4.714 4.714c-2.166 2.167-3.638 2.136-5.774 0l-4.714-4.714 1.06-1.06z"}));
}

Down.defaultProps = {"width":"24","height":"24"};

module.exports = Down;

Down.default = Down;
